module.exports = __webpack_public_path__ + "img/s4.e5bc3ccd.png";